
// function toggleFaq() {
// 	var element = document.getElementById('courseDescription');
// 	var button = document.getElementById('readMore');
// 	var fade = document.getElementById('tallFade');
	
// 	if (element.offsetHeight > 250) {
// 		element.classList.add("tall");
// 		button.classList.add("active");
// 		// button.classList.add("active");
// 	} else {
// 		return;
// 	}
// }

if (false) $( document ).ready(function() {
	$('.answer-wrapper').hide();
	$(".wrapper").click(function() {
		console.log('clicked yo.');
		$(this).next(".wrapper").fadeToggle();
	});
});